// src/components/UI.jsx
import React from "react";
import { fmt } from "../config/devices";

export function StatCard({ label, value, sub, color, accent }) {
  return (
    <div style={{ background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: 12, padding: "18px 20px", flex: 1, minWidth: 140 }}>
      <div style={{ fontSize: 10, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700, fontFamily: "var(--font-head)", color: color || "var(--text)", lineHeight: 1 }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 6 }}>{sub}</div>}
    </div>
  );
}

export function CampusBadge({ campus }) {
  const col = campus === "CCK" ? "var(--cck)" : campus === "CCW" ? "var(--ccw)" : "var(--muted)";
  return (
    <span style={{ background: col + "18", color: col, padding: "2px 8px", borderRadius: 8, fontSize: 11, fontWeight: 600, fontFamily: "var(--font-mono)" }}>
      {campus}
    </span>
  );
}

export function StatusBadge({ status }) {
  const map = {
    "In Use":           { color: "var(--success)", bg: "#22c55e18" },
    "Spare":            { color: "var(--warn)",    bg: "#f59e0b18" },
    "ICT Provisioning": { color: "var(--accent)",  bg: "#4f9cf918" },
    "NOT YET RECEIVED": { color: "var(--muted)",   bg: "rgba(255,255,255,0.05)" },
  };
  const s = map[status] || { color: "var(--muted)", bg: "rgba(255,255,255,0.05)" };
  return (
    <span style={{ background: s.bg, color: s.color, padding: "2px 8px", borderRadius: 8, fontSize: 11, fontWeight: 500 }}>
      {status || "—"}
    </span>
  );
}

export function HBar({ label, count, max, color, sub }) {
  const pct = max > 0 ? Math.round((count / max) * 100) : 0;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
      <div style={{ width: 140, fontSize: 12, color: "var(--text)", flexShrink: 0, textAlign: "right", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{label}</div>
      <div style={{ flex: 1, height: 22, background: "rgba(255,255,255,0.05)", borderRadius: 4, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, height: "100%", background: color || "var(--accent)", borderRadius: 4, display: "flex", alignItems: "center", paddingLeft: 8, minWidth: count > 0 ? 24 : 0, transition: "width 0.5s" }}>
          {count > 0 && <span style={{ fontSize: 11, fontWeight: 600, color: "#fff", fontFamily: "var(--font-mono)" }}>{count}</span>}
        </div>
      </div>
      {sub && <div style={{ fontSize: 12, color: "var(--muted)", minWidth: 80, textAlign: "right", fontFamily: "var(--font-mono)" }}>{sub}</div>}
    </div>
  );
}

export function YearPill({ year, devices, isSelected, onClick, maxCount, devicePrice = 1704 }) {
  const realBudget = devices.filter(d => d.deviceType === "Staff Device").length * devicePrice;
  const now = new Date().getFullYear();
  const isPast = year < now;
  const isCurrent = year === now;
  return (
    <div onClick={onClick} style={{ background: isSelected ? "var(--accent)" : "var(--bg2)", border: `1px solid ${isSelected ? "var(--accent)" : "var(--border)"}`, borderRadius: 12, padding: "14px 16px", cursor: "pointer", opacity: isPast ? 0.45 : 1, minWidth: 120, position: "relative", transition: "all 0.18s", flexShrink: 0 }}>
      {isCurrent && <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", background: "var(--warn)", color: "#000", fontSize: 9, fontWeight: 700, padding: "2px 8px", borderRadius: 20, whiteSpace: "nowrap", letterSpacing: "0.08em", fontFamily: "var(--font-mono)" }}>NOW</div>}
      <div style={{ fontSize: 16, fontWeight: 700, fontFamily: "var(--font-head)", color: isSelected ? "#fff" : "var(--text)" }}>{year}</div>
      <div style={{ fontSize: 28, fontWeight: 800, fontFamily: "var(--font-head)", color: isSelected ? "#fff" : (devices.length > 40 ? "var(--danger)" : "var(--text)"), lineHeight: 1, margin: "4px 0" }}>{devices.length}</div>
      <div style={{ fontSize: 10, color: isSelected ? "rgba(255,255,255,0.6)" : "var(--muted)", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em" }}>devices</div>
      <div style={{ height: 3, background: isSelected ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.05)", borderRadius: 2, overflow: "hidden", marginBottom: 8 }}>
        <div style={{ width: `${maxCount > 0 ? Math.round((devices.length / maxCount) * 100) : 0}%`, height: "100%", background: isSelected ? "rgba(255,255,255,0.6)" : "var(--warn)", borderRadius: 2 }} />
      </div>
      <div style={{ fontSize: 11, fontWeight: 600, color: isSelected ? "rgba(255,255,255,0.85)" : "var(--warn)", fontFamily: "var(--font-mono)" }}>{fmt(realBudget)}</div>
    </div>
  );
}

export function FilterBtn({ label, active, onClick, color }) {
  return (
    <button onClick={onClick} style={{ background: active ? (color || "var(--accent)") : "var(--bg3)", border: `1px solid ${active ? (color || "var(--accent)") : "var(--border)"}`, color: active ? "#fff" : "var(--muted)", padding: "5px 14px", borderRadius: 6, cursor: "pointer", fontSize: 12, fontWeight: 500, transition: "all 0.15s" }}>
      {label}
    </button>
  );
}

export function SectionTitle({ children, action }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
      <h2 style={{ fontFamily: "var(--font-head)", fontSize: 16, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.01em" }}>{children}</h2>
      {action}
    </div>
  );
}

export function Card({ children, style }) {
  return (
    <div style={{ background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: 12, padding: 20, ...style }}>
      {children}
    </div>
  );
}

export function DropZone({ label, sublabel, onFile, loaded, fileName, color, onClear }) {
  const [drag, setDrag] = React.useState(false);
  const onDrop = e => { e.preventDefault(); setDrag(false); const f = e.dataTransfer.files[0]; if (f) onFile(f); };
  return (
    <div onDragOver={e => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)} onDrop={onDrop}
      style={{ flex: 1, border: `1.5px dashed ${loaded ? (color || "var(--accent)") : drag ? "var(--accent)" : "var(--border2)"}`, borderRadius: 12, padding: "20px 18px", textAlign: "center", background: loaded ? (color || "var(--accent)") + "08" : drag ? "rgba(79,156,249,0.05)" : "var(--bg3)", transition: "all 0.2s", position: "relative" }}>
      {loaded && onClear && (
        <button onClick={onClear} style={{ position: "absolute", top: 8, right: 10, background: "none", border: "none", color: "var(--muted)", cursor: "pointer", fontSize: 16 }}>✕</button>
      )}
      <div style={{ fontSize: 24, marginBottom: 8 }}>{loaded ? "✓" : "↑"}</div>
      <div style={{ fontSize: 13, fontWeight: 600, color: loaded ? (color || "var(--accent)") : "var(--text)", marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: loaded ? 0 : 12 }}>{loaded ? fileName : sublabel}</div>
      {!loaded && (
        <label style={{ display: "inline-block", background: "var(--accent)", color: "#fff", padding: "6px 16px", borderRadius: 6, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
          Browse <input type="file" accept=".csv" style={{ display: "none" }} onChange={e => e.target.files[0] && onFile(e.target.files[0])} />
        </label>
      )}
    </div>
  );
}
